import React from 'react';
import { NavLink as RouterLink } from "react-router-dom";

import footerLogo from "../../images/logo-big-shop2.png";
import SocialProfileLinks from './SocialProfileLinks';

function Footer2() {
    return (
        <>
        <style>{`
            .center{
                text-align:center;
            }

            .white-light{
                color: #ffffffff !important;
                font-size: 16px !important;
            }

            .social-list {
            list-style: none;
            display: flex;              /* horizontal */
            justify-content: center;    /* center in footer */
            align-items: center;
            gap: 16px;                  /* space between icons */
            padding: 0;
            margin: 0 0 10px 0;
            }


            .social-list li a {
            color: #fff;
            font-size: 20px;
            transition: color 0.3s ease;
            }

            .social-list li a:hover {
            color: #00bcd4;
            }
            /* Donate CTA background */
            .donate-cta-section {
  background: linear-gradient(to right, #ffdb5e 0%, #ffffff 100%)
}

            /* Remove inherited dark backgrounds */
            .donate-cta-section .fog-action-buttons,
            .donate-cta-section .section-sub-title {
              background: transparent !important;
            }
            /* Force black text for donate CTA line */
            .donate-cta-section .donate-text {
              color: #000 !important;
            }
            
.footer-bottom-custom {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 30px;
  padding: 40px 0;
  margin-left: 40px;   /* 👈 move slightly to right */
}
.footer-bottom-custom {
  width: 100%;
}

.footer-logo-left {
  margin-top: 5px;   /* fine adjustment to align with icons */
}
.donate-cta-section .white-light {
  color: #000000 !important;
}
/* Volunteer Button */
.volunteer-btn {
  background: #05386dff !important;
  color: #fff !important;
  border: none;
}

.volunteer-btn:hover {
  background: #0056b3 !important;
  color: #fff !important;
}            

            

        `}</style>
        {/* DONATE CTA SECTION */}
        <div className="donate-cta-section">
          <div className="container">
            <div className="row">
              <div className="section-sub-title center" style={{ paddingTop: 50 }}>
                <article className="section-title-body">
                  <p
  className="white-light mt-3 footer-responsive-center"
  style={{ color: "#000000" }}
>
  Festival of Globe is a 501(C)(3) organization, Non-Profit Tax ID #33-4077321, All donations are 100% tax deductible.
</p>
                </article>
              </div>

              <div
  className="row justify-content-center"
  style={{ paddingBottom: 50 }}
>
  <div
    className="fog-action-buttons"
    style={{
      display: "flex",
      gap: "15px",
      justifyContent: "center",
      flexWrap: "wrap",
    }}
  >
    {/* Donate Button */}
    <a
      href="https://givebutter.com/Nnf9Vr"
      target="_blank"
      rel="noopener noreferrer"
      className="fog-btn"
    >
      Donate
    </a>

    {/* Become Volunteer Button */}
    <RouterLink
      to="/fog-volunteer"
      
      className="fog-btn volunteer-btn"
    >
      Become Karmayogi (volunteer)
    </RouterLink>
  </div>
</div>
            </div>
          </div>
        </div>

        <footer id="footer">
            <div className="container">
                {/* <div className="row">
                    <div className="col-md-12">
                        <article className="footer-info-block">
                            
                            <ul className="list-unstyled flickr">
                                <li><a href="/"><img src="img/preview/blog1.jpg" className="img-fluid" alt=""/></a></li>
                                <li><a href="/"><img src="img/preview/blog2.jpg" className="img-fluid" alt=""/></a></li>
                                <li><a href="/"><img src="img/preview/blog5.jpg" className="img-fluid" alt=""/></a></li>
                                <li><a href="/"><img src="img/preview/blog3.jpg" className="img-fluid" alt=""/></a></li>
                                <li><a href="/"><img src="img/preview/blog4.jpg" className="img-fluid" alt=""/></a></li>
                                <li><a href="/"><img src="img/preview/blog6.jpg" className="img-fluid" alt=""/></a></li>
                                <li><a href="/"><img src="img/preview/blog8.jpg" className="img-fluid" alt=""/></a></li>
                            </ul>
                        </article>
                    </div> 
                </div> */}
                
                <div className="row">
                    <div className="col-xl-3 col-md-6">
                        <article className="footer-info-block">
                            <div className="section-sub-title">
                                <article className="section-title-body white">
                                    <h4 className="head-title">Festival of Globe</h4>
                                </article>
                            </div>
                            {/* <p>Festival of Globe<br/> */}
                           <p className='white-light'> A 501 (C)(3) Non Profit Organization,<br/>
                            TAX ID: 33-4077321.<br/>
                            3155 Kearney Street, Suite 210, Fremont, CA 94538.<br/>
                            United States.<br/>
                            </p>
                        </article>
                    </div>
                    <div className="col-xl-3 col-md-6">
                        <article className="footer-info-block">
                            <div className="section-sub-title">
                                <article className="section-title-body white">
                                    <h4 className="head-title">Engage With Us</h4>
                                </article>
                            </div>
                            <ul className="list-unstyled">
                                <li><RouterLink to="/contact-us" >Contact Us</RouterLink></li>
                                <li><a href="https://www.fogsv.com/sponsorship-2026/" target="_blank" rel="noopener noreferrer">Sponsorship</a></li>
                                <li>
                                  <RouterLink
                                    to="/membership-and-volunteer"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    Get involved
                                  </RouterLink>
                                </li>
                                <li>
                                                                  <RouterLink
                                                                    to="/membership-and-volunteer"
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                  >
                                                                    Make a Donation
                                                                  </RouterLink>
                                                                </li>
                            </ul>
                        </article>


                    </div>
                    <div className="col-xl-3 col-md-6">
                        <article className="footer-info-block">
                            <div className="section-sub-title">
                                <article className="section-title-body white">
                                    <h4 className="head-title">Our Events</h4>
                                </article>
                            </div>
                            <ul className="list-unstyled">
                                <li><RouterLink to="/fog-festivals-and-programs#upcoming-events" >FOG 2026 – Program schedule</RouterLink></li>
                                
                                <li><RouterLink to="/events-and-calender#pac">Americans4Hindus – Political Action Committee Events</RouterLink></li>
                                <li><RouterLink to="/events-and-calender#npo" >Americans4Hindus – 501 (c)(3) - Non Profit organization Events</RouterLink></li>
                                <li><RouterLink to="/events-and-calender#fog" >Festival of Globe – 501 (c)(3)- Non Profit organization Events</RouterLink></li>
                                
                            </ul>
                        </article>
                    </div>
                    <div className="col-xl-3 col-md-6">
                        <article className="footer-info-block">
                            <div className="section-sub-title">
                                <article className="section-title-body white">
                                    <h4 className="head-title">Mission & Goals</h4>
                                </article>
                            </div>
                            <ul className="list-unstyled">
                                <li><RouterLink to="/hindu-rajneeti-academy"  >   Hindu Rajneeti Academy </RouterLink></li>
                                                                <li><RouterLink to="/a4h-temple-rakshak"  > A4H TEMPLE RAKSHAK</RouterLink></li>
                                                                <li><RouterLink to="/a4h-voter-guide"  > A4H HINDU VOTERS GUIDE </RouterLink></li>
                                                                <li><RouterLink to="/a4h-state-pacs"  >  A4H MULTIPLE STATE PACS </RouterLink></li>
                                                                <li><RouterLink  to="/hindu-way-of-living"  > HINDU WAY OF LIVING </RouterLink></li>  
                                                                <li><RouterLink to="/events-and-calender"  >  UPCOMING EVENTS </RouterLink></li>
                                                                <li><RouterLink to="/membership-and-volunteer"  >  MEMBERSHIP & VOLUNTEER </RouterLink></li>
                            </ul>
                        </article>
                    </div>
                    <div className="footer-bottom-custom">

  {/* Logo (left) */}
  <div className="footer-logo-left">
  <RouterLink to="/">
    <img
      src={footerLogo}
      alt="Americans4Hindus Logo"
      style={{ height: "90px" }}
    />
  </RouterLink>
</div>

  {/* Center Content */}
  <div className="footer-center-content">
    <SocialProfileLinks brand="fog" />

    <p className="white-light mt-3">
      Festival of Globe is a 501(C)(3) organization, Non-Profit Tax ID #33-4077321, All donations are 100% tax deductible.
    </p>
  </div>

</div>
                </div>
                

            </div>

        </footer>
        </>
    )
}

export default Footer2
